module.exports = __webpack_public_path__ + "static/media/infomobile.f7d50323.jpg";